import { Box } from "@mui/material";
import React from "react";
import { QueryFieldTypes, QueryInfo } from "system/query/QueryInfo";
import { QueryFieldSelector } from "../../dialogParts/QueryFieldSelector";
import { QueryFieldsSelector } from "../../dialogParts/QueryFieldsSelector";
import { queryOps } from "system/query/Query";
import { defaultQueryFieldTypeOrder, getAllowedFieldTypesByOp } from "system/query/QueryUtility";

export interface QueryLeafNodeFieldsProps {
  queryInfo: QueryInfo;

  fields: string[];
  setFieldIds: (fields?: string[]) => void;

  op?: string;
}

export function QueryLeafNodeFields(props: QueryLeafNodeFieldsProps): JSX.Element {
  const { queryInfo, fields, setFieldIds, op } = props;

  const firstFieldId = fields?.length ? fields[0] : null;
  const firstField = queryInfo.fields.find(field => field.id === firstFieldId);

  const fieldTypes = op ? getAllowedFieldTypesByOp(op as queryOps) : defaultQueryFieldTypeOrder;

  return (
  <Box>
    {firstField?.type !== QueryFieldTypes.text &&
      <QueryFieldSelector
        allowedFieldTypes={fieldTypes}
        selectedFieldId={firstFieldId || null}
        setSelectedFieldId={(newFieldId: string) => {
          const fields = newFieldId ? [newFieldId] : [];
          setFieldIds(fields);
        }}
        fields={props.queryInfo.fields}
        typeOrder={defaultQueryFieldTypeOrder}
        requireQuerySupported={true}
      ></QueryFieldSelector>
    }
    {firstField?.type === QueryFieldTypes.text &&
      <QueryFieldsSelector
        allowedFieldTypes={fieldTypes}
        restrictToSingleType={true}
        selectedFieldIds={fields}
        setSelectedFieldIds={(newFieldIds: string[]) => {
          setFieldIds(newFieldIds);
        }}
        queryInfo={props.queryInfo}
        requireQuerySupported={true}
      ></QueryFieldsSelector>
    }
    </Box>
  );
}